import styled from 'styled-components'

export default styled.span`
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.colors.danger};
`
